/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Container = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  height: ${({ height }) => (height ? `${height}px` : '100%')};
  gap: 8px;
  color: ${Palette.PrimaryGray._700};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  cursor: pointer;
  border: 1px solid ${Palette.PrimaryGray._200};
  background: #fff;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.05);
  padding: 10px 24px;
  :hover {
    ${({ pressed }) =>
      !pressed
        ? css`
            border: 1px solid ${Palette.Primary._300};
            color: ${Palette.Primary._500};
          `
        : css`
            cursor: auto;
          `}
  }
  :active {
    border: 1px solid ${Palette.Primary._300};
    background: ${Palette.Primary._000};
    color: ${Palette.PrimaryGray._700};
  }
  :disabled {
    background: ${Palette.PrimaryGray._000};
    border: 1px solid ${Palette.PrimaryGray._200};
    color: ${Palette.PrimaryGray._900};
    opacity: 0.5;
    cursor: not-allowed;
  }
  ${({ variant }) => {
    if (variant === 'left') {
      return css`
        border-radius: 4px 0px 0px 4px;
      `;
    }
    if (variant === 'center') {
      return css`
        border-left: none;
        border-right: none;
      `;
    }
    if (variant === 'right') {
      return css`
        border-radius: 0px 4px 4px 0px;
      `;
    }
  }}

  ${({ pressed }) =>
    pressed &&
    css`
      border: 1px solid ${Palette.Primary._300};
      background: ${Palette.Primary._000};
      color: ${Palette.PrimaryGray._700};
    `}
`;

export const IconContainer = styled.div``;

export const Desc = styled.p`
  text-align: left;
  color: ${Palette.PrimaryGray._500};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const Text = styled.p`
  white-space: nowrap;
`;
